export const HTML_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  BAD_REQUEST: 400,
  SUCCESS: 200
};
export const appVersion = require('../../../package.json').version;

export const consoleMessagesLimit = 200;
